import '@assets/styles/tiptap-preview.css';

import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { eventApiClient } from '@src/api/tenant/event/eventApiClient';
import { Event } from '@src/api/types/event';
import EventContent from '@src/features/shared/EventContent';
import { TENANT_URL } from '@src/routes/tenant';
import React, { useEffect, useState } from 'react';
import { generatePath, useParams } from 'react-router-dom';

const EventPreview: React.FC = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const [event, setEvent] = useState<Event | undefined>(undefined);

  const shareData = event
    ? {
        url: `${window.location.origin}${generatePath(TENANT_URL.EVENTS_PREVIEW, { uuid: uuid })}`,
        title: event.title,
        tags: event.media_tags ? event.media_tags.map((tag) => tag.name) : [],
        disabled: true,
      }
    : null;

  useEffect(() => {
    const fetchData = async () => {
      if (!uuid) {
        return;
      }

      const res = await eventApiClient.findByEventPreviewUuid(uuid);
      handleApiResponse(res, async (data) => {
        setEvent(data);
      });
    };

    fetchData();
  }, [uuid]);

  return (
    <main className='px-6 py-10 lg:pt-4'>
      <div className='m-auto max-w-[740px] lg:px-6'>
        {event && (
          <EventContent
            event={event}
            showApplicationButton={true}
            showFloatingButton={true}
            shareData={shareData}
          />
        )}
      </div>
    </main>
  );
};

export default EventPreview;
